import { Resource as i, API as l } from "@coveo/platform-client";
const e = class e extends i {
  list(t, a) {
    return this.api.get(
      this.buildPath(e.baseUrl, { ...a, trackingId: t })
    );
  }
  // Like list(), but returns only basic information about the listing configuration (id, name, trackingId, patterns)
  partial(t) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/partial`, t)
    );
  }
  create(t) {
    return this.api.post(e.baseUrl, t);
  }
  delete(t) {
    return this.api.delete(`${e.baseUrl}/${t}`);
  }
  update(t, a) {
    return this.api.put(
      `${e.baseUrl}/${t}`,
      a
    );
  }
  get(t) {
    return this.api.get(`${e.baseUrl}/${t}`);
  }
  getGlobal(t) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/global`, { trackingId: t })
    );
  }
  updateGlobal(t) {
    return this.api.put(`${e.baseUrl}/global`, t);
  }
  listNames(t) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/names`, t)
    );
  }
  /**
   * Update the facet collection configuration association for a listing configuration
   * @param configurationId
   * @param facetCollectionId
   */
  associateFacetCollection(t, a) {
    return this.api.put(
      `${e.baseUrl}/${t}/facetCollection`,
      { facetCollectionConfigurationId: a }
    );
  }
  /**
   * Delete the facet collection configuration association for a listing configuration
   * @param configurationId
   */
  disassociateFacetCollection(t) {
    return this.api.delete(`${e.baseUrl}/${t}/facetCollection`);
  }
};
e.baseUrl = `/rest/organizations/${l.orgPlaceholder}/commerce/v2/configurations/listings`;
let s = e;
export {
  s as ProductListingConfiguration
};
//# sourceMappingURL=ProductListingConfiguration.js.map
